<app-header-one [sticky]="true" #TopHeader></app-header-one>
<div [ngStyle]="{'margin-top': height}">
    <router-outlet  ></router-outlet>
</div>
<app-footer-one></app-footer-one>
